import { css } from '@emotion/css';
import { computed } from 'vue';
import { useTheme } from '../../composables/theme';

export const useStyles = () => {
  const theme = useTheme();
  const baseClass = computed(() => css({
    margin: 0,
    padding: 0,
    width: 'fit-content',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.625rem',
    color: theme.value.colors.primary.main,
    '&:hover:not(&:disabled)': {
      color: theme.value.colors.primary.ultraDark,
    },
    '&:focus': {
      color: theme.value.colors.primary.light1,
    },
    textDecoration: 'underline',
    fontWeight: 600,
    '&--large': {
      lineHeight: '1.5rem',
      fontSize: '1.125rem',
    },
    '&--medium': {
      lineHeight: '1.375rem',
      fontSize: '1rem',
    },
    '&--small': {
      lineHeight: '1.25rem',
      fontSize: '0.875rem',
    },
  }));

  return baseClass;
};
